import { getMultiSelectMessage } from '../../../utils/formValidation/errorMessageFunctions';

export const validate = (admin) => {
    let newErrors = {};

    if (admin.selectedEthnicities.length < 1) {
        newErrors = {
            ...newErrors,
            ethnicities: { error: true, message: getMultiSelectMessage('ethnicity') }
        };
    }
    if (admin.selectedFirstLanguages.length < 1) {
        newErrors = {
            ...newErrors,
            firstLanguages: { error: true, message: getMultiSelectMessage('first language') }
        };
    }
    if (admin.selectedDriversLicences.length < 1) {
        newErrors = {
            ...newErrors,
            driversLicences: { error: true, message: getMultiSelectMessage('drivers licence type') }
        };
    }
    if (admin.selectedMaritalStatuses.length < 1) {
        newErrors = {
            ...newErrors,
            maritalStatuses: { error: true, message: getMultiSelectMessage('marital status') }
        };
    }
    if (admin.selectedHousing.length < 1) {
        newErrors = {
            ...newErrors,
            housing: { error: true, message: getMultiSelectMessage('housing type') }
        };
    }
    if (admin.selectedAttractions.length < 1) {
        newErrors = {
            ...newErrors,
            attractions: { error: true, message: getMultiSelectMessage('attraction type') }
        };
    }
    return newErrors;
};
